import { useMemo } from 'react';
import { ICON_PATHS, resolveIcon } from './toolIcons';

type ToolIconProps = {
  icon: string;
  size?: number;
  className?: string;
};

/**
 * Rend une icône SVG inlinée (style trait fin, hérite de la couleur via
 * `currentColor`). Résout l'emoji du catalogue vers le jeu d'icônes cohérent ;
 * en dernier recours (emoji inconnu) retourne l'emoji d'origine pour ne jamais
 * afficher une icône invisible.
 */
export function ToolIcon({ icon, size = 18, className }: ToolIconProps) {
  const inner = useMemo(() => {
    const key = resolveIcon(icon);
    return ICON_PATHS[key];
  }, [icon]);

  if (!inner) {
    return <span className={className} aria-hidden="true">{icon}</span>;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: inner }}
    />
  );
}
